export const URL_QUERY_PARAM_INTERACTION_SESSION = 'xpis';

export const generateUrlWithParams = (
	url: string,
	bridge: string,
	interactionSessionId: string,
	product: string,
	subProduct?: string,
): string => {
	const interactionSource = subProduct ? `${product}-${subProduct}` : product;

	const interactionSession = {
		bridge: bridge,
		id: interactionSessionId,
		source: interactionSource,
	};

	const paramValueEncoded = btoa(JSON.stringify(interactionSession));

	const urlObj = new URL(url);
	urlObj.searchParams.set(URL_QUERY_PARAM_INTERACTION_SESSION, paramValueEncoded);

	return urlObj.toString();
};
